import {IconButton, styled} from "@mui/material";


export const StyledAddButton = styled(IconButton)({
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    svg: {
      g: {
        rect: {
          fill: 'linear-gradient(137deg, #1131F5 0%, #63BAD0 100%',
        }
      }
    }
  }
})